import React from 'react'
const Card_2 = (props) => {
    const {icon, title, subTitle} = props;
    return (
        <div className="feature-box has_fade_anim" style={{ transform: 'translate(0px, 0px)', opacity: 1 }}>
            <div className="thumb">
                <img src={icon} alt="feature icon"/>
            </div>
            <div className="content mt-4">
                <h3 className="title text-grad-3 fs-1">{title}</h3>
                <p className="text mt-0 fs-3 text-gray-800">{subTitle}</p>
                <span className="wc-btn wc-btn-normal fs-4">
                    Read more
                    <i className="fa-solid fa-arrow-right"></i>
                </span>
            </div>
        </div>
    )
}

export {Card_2}